import { render, staticRenderFns } from "./JoditEditor.vue?vue&type=template&id=7078e1a8&scoped=true&"
import script from "./JoditEditor.vue?vue&type=script&lang=ts&"
export * from "./JoditEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078e1a8",
  null
  
)

export default component.exports